import { card } from './reducers';
export default card;
